<template>
  <div>
    <v-card
      class="mx-auto"
      max-width="700"
    >
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
        <v-avatar
          v-if="step > -1"
          color="primary lighten-2"
          class="subheading white--text"
          size="24"
          v-text="step + 1"
        ></v-avatar>
      </v-card-title>

      <v-window v-model="finishedStep" v-if="finished">
        <v-window-item
          :key="`card-${-2}`"
          :value="-2"
        >
          <v-card-text>
            <span class="subheading grey--text text--darken-1">
              La encuesta ha sido finalizada
            </span>
          </v-card-text>
        </v-window-item>
      </v-window>
      <v-window v-model="step" v-else>
        <v-window-item
          :key="`card-${-1}`"
          :value="-1"
        >
          <v-card-text>
            <span class="subheading grey--text text--darken-1">
              {{ surveyToRun.description }}
            </span>
          </v-card-text>
        </v-window-item>
        <v-window-item
          v-for="(question, i) in surveyToRun.questions"
          :key="`card-${i}`"
          :value="i"
        >
          <v-card-text>
            <div v-if="question.type === 'TEXT'">
              <v-textarea outline
                label="Respuesta"
                name="name"
                v-model="answers[question.id]"
              ></v-textarea>
            </div>
            <div v-if="question.type === 'ONLY_OPTION'">
              <v-radio-group
                v-model="answers[question.id]"
              >
                <v-radio
                  v-for="(option, k) in question.options"
                  :label="option.text"
                  :key="`radio-${k}`"
                  :value="`${option.id}~${option.value}`"
                >
                </v-radio>
              </v-radio-group>
            </div>
            <answer-multiple
               v-if="question.type === 'MULTIPLE_OPTION'"
              :question="question"
              v-on:setValue="setAnswer"
            />
          </v-card-text>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          :disabled="step === -1 || finished"
          flat
          @click="step--"
        >
          Atrás
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="step > -1 && step === surveyToRun.questions.length - 1"
          color="primary"
          depressed
          @click="endSurvey"
          :disabled="finished"
        >
          {{ finished ? 'Finalizada' : 'Finalizar' }}
        </v-btn>
        <v-btn
          v-else-if="step === -1"
          color="primary"
          depressed
          @click="startSurvey"
        >
          {{ existing_survey.id > 0 ? 'Continuar' : 'Comenzar' }}
        </v-btn>
        <v-btn
          v-else
          color="primary"
          depressed
          @click="step++"
        >
          Siguiente
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import  { mapGetters } from 'vuex'

  import answerMultiple from './answer-multiple.vue'
  export default {
    name: 'run-survey-start',
    components: {
      'answer-multiple': answerMultiple,
    },
    data() {
      return {
        step: -1,
        surveyToRun: {
          questions: []
        },
        answers: {},
        external_app: 'PUBLIC_SURVEY',
        external_app_id: 0,
        external_app_process_id: 0,
        finished: false,
        survey_response_id: 0,
        existing_survey: { id: 0, status: 0 },
        finishedStep: -2,
      }
    },
    created () {
      const surveyId = this.$route.params.surveyId
      if (!surveyId) {
        this.$store.dispatch('responseMessage', {
          type: 'warning',
          text: 'No se proporcionaron los datos necesarios para iniciar la encuesta',
          title: 'Encuesta',
          modal: true
        })
        return;
      }
      this.init(surveyId)
    },
    computed: {
      currentTitle() {
        if (this.step === -1 || this.finished) {
          return this.surveyToRun.name
        }
        return this.surveyToRun.questions[this.step].title
      }
    },
    methods: {
      init(surveyId) {
        axios.get(`/api/public_survey/run/${surveyId}`)
          .then(response => {
            if (response.status === 200) {
              this.surveyToRun = response.data.survey
              if (response.data.existingSurvey) {
                this.existing_survey = response.data.existingSurvey
                this.survey_response_id = this.existing_survey.id
                if (this.existing_survey.status == 1) {
                  this.finished = true;
                  this.step = this.surveyToRun.questions.length - 1
                }
              }
              this.surveyToRun.questions.forEach(question => {
                if (question.type === 'MULTIPLE_OPTION') {
                  this.answers[question.id] = []
                } else {
                  this.answers[question.id] = ''
                }
              });
            }
          })
      },
      startSurvey() {
        if (this.existing_survey.id > 0) {
          this.step += 1;
          return;
        }
        const payload = {
          survey_id: this.surveyToRun.id,
          user_id: 0,
          student_id: 0,
          external_app: this.external_app,
          external_app_id: this.external_app_id,
          external_app_process_id: this.external_app_process_id,
          status: 0,
        }
        axios.post('/api/public_survey/start', payload)
          .then(response => {
            if (response.status === 200) {
              this.step += 1;
              this.survey_response_id = response.data.id
              return;
            }
            this.$store.dispatch('responseMessage', {
            type: 'warning',
              text: 'No se pudo iniciar la encuesta, intente nuevamente por favor.',
              title: 'Encuesta',
              modal: true
            })
          })
      },
      setAnswer({ newValue, questionId }) {
        this.answers[questionId] = [ ...newValue ]
      },
      endSurvey() {
        const payload = this.surveyToRun.questions.map(question => {
          if (question.type === 'MULTIPLE_OPTION') {
            return this.answers[question.id].map(option => {
              const { id, value } = this.getOptionIdValue(option)
              return {
                survey_id: question.survey_id,
                survey_question_id: question.id,
                survey_question_option_id: id,
                text_response: value,
                external_app: this.external_app,
                external_app_id: this.external_app_id,
                external_app_process_id: this.external_app_process_id,
                survey_response_id: this.survey_response_id,
                user_id: 0,
              }
            })
          } else {
            const { id, value } = this.getOptionIdValue(this.answers[question.id])
            return {
              survey_id: question.survey_id,
              survey_question_id: question.id,
              survey_question_option_id: question.type !== 'TEXT' ? id : '',
              text_response: question.type === 'TEXT' ? this.answers[question.id] : value,
              external_app: this.external_app,
              external_app_id: this.external_app_id,
              external_app_process_id: this.external_app_process_id,
              survey_response_id: this.survey_response_id,
              user_id: 0,
            }
          }
        })

        axios.post('/api/public_survey/answer', payload.flat())
          .then(response => {
            if (response.status === 200) {
              this.finishResponse();
              this.$store.dispatch('responseMessage', {
                type: 'success',
                text: 'Respuestas guardadas correctamente. Encuesta terminada.',
                title: 'Encuesta',
                modal: true
              })
            }
          })
      },
      getOptionIdValue(option) {
        const [id, value] = option.split('~')
        return {
          id,
          value
        };
      },
      finishResponse() {
        const payload = {
          id: this.survey_response_id
        };
        axios.post('/api/public_survey/finish', payload)
          .then(response => {
            if (response.status === 200) {
              this.finished = true
            }
          })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/surveys/run/public_survey.vue